export const environmentProd = {
    production: true,
    nui: "0",
    canal: "OtrosiClientes_prod",
    requiere_firma: true,
    session: "session",
    tokenUrl: "https://api.satelitales.col.bayport-digital.com/bayport-api-mgr/login",
    urlBase: "https://api.satelitales.col.bayport-digital.com/bayport-api-mgr/api/ado/cliente/findByNumberId",
    urlConsultaEstado: "https://api.satelitales.bayport-digital.com/v1/legalother/api/v1/documents/get-doc"
};
